import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _pick from "lodash/pick";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable camelcase */
import { load } from 'js-yaml';
import { MigrationResult } from './migration-result';
export var migrateV0ToV1 = function migrateV0ToV1(data) {
  var baseData = _pick(data, ['title', 'xp', 'course_id', 'chapter_id', 'assignment', 'instructions', 'hint', 'sct', 'pre_exercise_code', 'language', 'runtime_config']);

  var sampleCode = data.sample_code === '' ? [] : load(data.sample_code);
  var solution = data.solution === '' ? [] : load(data.solution);
  return new MigrationResult('v1', _objectSpread(_objectSpread({}, baseData), {}, {
    sample_code: sampleCode,
    solution: solution
  }));
};
export var migrateV1ToV2 = function migrateV1ToV2(_ref) {
  var sample_code = _ref.sample_code,
      solution = _ref.solution,
      data = _objectWithoutProperties(_ref, ["sample_code", "solution"]);

  return new MigrationResult('v2', _objectSpread(_objectSpread({}, data), {}, {
    sampleCodeFiles: sample_code,
    solutionCodeFiles: solution
  }));
};
export var migrations = {
  v0: migrateV0ToV1,
  v1: migrateV1ToV2
};
export default migrations;